import { initBridge } from './src';

export const asyncRunInitBridge = () => {
	initBridge();
};
